const UtmTags = () => {
  // Функция добавления UTM меток в url сайта
  const updateQueryStringParam = function (value) {
    let baseUrl = [
        location.protocol,
        "//",
        location.host,
        location.pathname,
      ].join(""),
      params = "?" + value;

    params = params == "?" ? "" : params;
    window.history.replaceState({}, "", baseUrl + params);
  };
  
  const url = document.location.href,
    paramsStartIndex = url.indexOf("?"),
    hostname = window.location.hostname;

  if (paramsStartIndex > -1) {
    // Добавление UTM меток в session storage
    sessionStorage.setItem(
      "utm_tags",
      url.slice(paramsStartIndex + 1, url.length)
    );
    sessionStorage.setItem(
      "hostname",
      hostname
    );
  } else {
    // При переходе по страницам если сохранены метки в session
    // storage, то выполняем функцию по их добавлению в url 
    if (sessionStorage.getItem("utm_tags") && hostname == sessionStorage.getItem("hostname")) {
      updateQueryStringParam(sessionStorage.getItem("utm_tags"));
    }
  }
};

export default UtmTags;
